import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ProviderOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;
  width: 95%;
  margin-top: 20px;
`;

export const ProviderDataContainer = styled.div`
  text-align: left;
  max-width: 40vw;
`;

export const ProviderContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ProviderDataTitle = styled.h4``;

export const ProviderDataText = styled.p`
  margin-left: 5px;
`;